import Validate from './validateInputs';

const validate: Validate = new Validate();

export { default as utils } from './utils';
export { validate };
